import React from "react";
import { CloudUploadOutlined } from '@ant-design/icons';
import general from "../../../const/general.js";

// import 'antd/lib/icon/style/css';
// <h1>{load_files[language].title}</h1> */

import {Col, Row, Typography} from "antd";
// import load_files from "../../../const/load_files";

const Placeholder = ({getInputProps, getRootProps, error, touched, label, language}) => (
  <div
    {...getRootProps()}
    className={`placeholder-preview ${error && touched ? "has-error" : ""}`}
  >
    <input {...getInputProps()} />
    <Row style={{background: 'var(--colorPrimaryOpacity)'}} align={'middle'} justify={'center'} className={'h-100'}>
      <Col span={24}>
        <CloudUploadOutlined style={{fontSize: '50px'}} />
        <div>
          <span style={{fontWeight:'bold', color:'black'}}> {general[language].uploadClickHere} </span><span style={{color:'black'}}> {general[language].uploadOrDragDocs} </span>
        </div>
        <Typography>{label}</Typography>
      </Col>
    </Row>
  </div>
);

export default Placeholder;
